import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import BillSplitter from './components/BillSplitter';
import About from './components/About';

const App = () => {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (
    <BrowserRouter>
      <div className={`App ${darkMode ? 'dark-mode' : ''}`}>
        <Routes>
          <Route 
            path="/" 
            element={
              <div className="bubble">
                <BillSplitter darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
              </div>
            } 
          />
          <Route 
            path="/about" 
            element={
              <div className="bubble">
                <About darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
              </div>
            } 
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default App;
